import { render, staticRenderFns } from "./MenuColorButton.vue?vue&type=template&id=7915c6b2&"
import script from "./MenuColorButton.vue?vue&type=script&lang=ts&"
export * from "./MenuColorButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports